import React from 'react';

import { formatDateTimeLong } from '@neptune/shared/common-util';
import { Button, Layout, Text } from '@neptune/shared/venus-ui';

type ServiceAccountActivatedContentProps = {
  keyGeneratedBy?: string;
  keyGeneratedDate?: Date;
  onResetToken?: () => void;
  userComponent: React.FC<{ user: string }>;
  apiTokenSectionElement?: React.ReactElement;
};

export const ServiceAccountActivatedContent: React.FC<ServiceAccountActivatedContentProps> = ({
  apiTokenSectionElement,
  keyGeneratedBy,
  keyGeneratedDate,
  onResetToken,
  userComponent: UserWithAvatar,
}) => {
  return (
    <Text size="sm">
      <Layout.Column withPadding={['none', 'lg', 'lg']}>
        <Layout.Column spacedChildren="sm">
          {apiTokenSectionElement}
          {keyGeneratedBy && keyGeneratedDate ? (
            <Layout.Row spacedChildren="xs" wrap="wrap">
              <Text>Generated {formatDateTimeLong(keyGeneratedDate)} by </Text>
              <UserWithAvatar user={keyGeneratedBy} />
            </Layout.Row>
          ) : undefined}
        </Layout.Column>
        {onResetToken ? (
          <Text>
            <Button variant="link" data-role="reset-api-token" onClick={onResetToken}>
              Reset Token
            </Button>
          </Text>
        ) : undefined}
      </Layout.Column>
    </Text>
  );
};
